import Home from './pages/home.vue';
import Project from './pages/project.vue';
import Quote from './pages/quote.vue';
import Coming from './pages/coming.vue';

export const PublicRoutes = [
	{
		path: '/',
		component: Home,
		props: true,
		name: 'home',
	},
	{
		path: '/proyecto/:project_id',
		component: Project,
		props: true,
		name: 'project',
	},
	{
		path: '/cotizar/:project_id',
		component: Quote,
		props: true,
		name: 'quote',
	},
	{
		path: '/proximamente',
		component: Coming,
		props: true,
		name: 'coming',
	},
];